exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SearchableMultiSelect-d20f6d8e{font-size:16px;background:none;margin:0 0 20px 0;padding:10px 15px;border:1px solid #C8C8C8;border-radius:5px;-webkit-border-radius:5px;box-sizing:border-box;width:100%;height:100%;min-height:42px}.expandedInput-02364052{height:44px}\n", ""]);

// Exports
exports.locals = {
	"SearchableMultiSelect": "SearchableMultiSelect-d20f6d8e",
	"expandedInput": "expandedInput-02364052"
};